import React from 'react'
function TD(props) {
    return(
        <td style={{textAlign:'center'}}>
            {props.children}
        </td>
    )
}
export default TD;
